"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgSights = function SvgSights(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 26.561h23.49V28.5H6.5zm0-15.003c0-.51.304-.969.772-1.168l11.394-4.844 10.57 4.82a1.289 1.289 0 0 1-.535 2.46H7.77a1.269 1.269 0 0 1-1.269-1.268Zm1.506 1.612v.126a2 2 0 0 0 2 2h1.937a2 2 0 0 0 2-2v-.226m1.41.1v.126a2 2 0 0 0 2 2h1.937a2 2 0 0 0 2-2v-.226m1.41.1v.126a2 2 0 0 0 2 2h1.937a2 2 0 0 0 2-2v-.226M8.826 26.234V15.316m3.918 10.918V15.316m3.429 10.918V15.316m3.918 10.918V15.316m3.429 10.918V15.316m3.918 10.918V15.316"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgSights);
var _default = exports["default"] = Memo;